import { FIELD_LABEL } from './copyModel';

import { CopyContent, CopyDetail } from '@/services/lifecycleAPI';

export type DiffRow = {
  key: string;
  label: string;
  before: string;
  after: string;
};

const textOf = (
  content: CopyContent | null | undefined,
  defaults: CopyDetail['default'],
  variant: string,
  field: string,
): string => {
  const own = content?.[variant]?.[field];
  if (typeof own === 'string') return own;
  const fallback = defaults[variant]?.[field];
  return typeof fallback === 'string' ? fallback : '';
};

export const historyDiff = (detail: CopyDetail, index: number): DiffRow[] => {
  const item = detail.history[index];
  if (!item || item.reset || !item.content) return [];
  const previous = detail.history[index + 1]?.content ?? null;
  const pairs = new Set<string>();
  [item.content, previous].forEach((content) =>
    Object.entries(content ?? {}).forEach(([variant, fields]) =>
      Object.keys(fields).forEach((field) => pairs.add(`${variant}/${field}`)),
    ),
  );
  const multi = Object.keys(detail.default).length > 1;
  return Array.from(pairs).flatMap((pair) => {
    const [variant, field] = pair.split('/');
    const before = textOf(previous, detail.default, variant, field);
    const after = textOf(item.content, detail.default, variant, field);
    if (before === after) return [];
    const name = FIELD_LABEL[field] ?? field;
    return [
      {
        key: pair,
        label: multi ? `${variant} · ${name}` : name,
        before,
        after,
      },
    ];
  });
};
